import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DEFAULT_RASTER_OPACITY } from '../../../../cross-team-shared/state/layer-settings-state-2d';

@Component({
  selector: 'h3-raster-coding-layer-view-settings-popover',
  templateUrl: './raster-coding-layer-view-settings-popover.component.html',
  styleUrls: ['./raster-coding-layer-view-settings-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RasterCodingLayerViewSettingsPopoverComponent {
  defaultLayerOpacity = DEFAULT_RASTER_OPACITY;
}
